// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* SubirComprobante.css — /menu/comprobantes (tokens del tema, sin hex) */

.sc-cabecera {
  position: sticky;
  top: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  background: var(--sn-superficie);
  border-bottom: 1px solid var(--sn-borde);
}

.sc-volver {
  padding: 4px;
  border: none;
  background: none;
  color: var(--sn-accion);
  cursor: pointer;
}

.sc-titulo {
  font-size: 15px;
  font-weight: 700;
  color: var(--sn-texto);
}

.sc-cuerpo {
  max-width: 500px;
  margin: 0 auto;
  padding: 16px 16px 24px;
}

.sc-tarjeta {
  padding: 12px 14px;
  margin-bottom: 12px;
  border: 1px solid var(--sn-borde);
  border-radius: 14px;
  background: var(--sn-superficie);
}

.sc-seccion {
  margin-bottom: 8px;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--sn-texto-3);
}

.sc-entrada {
  width: 100%;
  min-height: 42px;
  padding: 9px 12px;
  border: 1.5px solid var(--sn-borde-fuerte);
  border-radius: 10px;
  background: var(--sn-superficie);
  color: var(--sn-texto);
  font-size: 14px;
  outline: none;
  box-sizing: border-box;
}

.sc-entrada:focus {
  border-color: var(--sn-foco-borde);
  box-shadow: 0 0 0 3px var(--sn-foco);
}

.sc-lista {
  margin-top: 6px;
  border: 1px solid var(--sn-borde);
  border-radius: 10px;
  overflow: hidden;
}

.sc-opcion {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  min-height: 44px;
  padding: 8px 12px;
  border: none;
  border-bottom: 1px solid var(--sn-borde);
  background: var(--sn-superficie);
  text-align: left;
  cursor: pointer;
}

.sc-opcion:last-child {
  border-bottom: none;
}

.sc-opcion-nombre {
  font-size: 13px;
  font-weight: 700;
  color: var(--sn-texto);
}

.sc-opcion-dato {
  font-size: 11px;
  color: var(--sn-texto-3);
}

.sc-cliente {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.sc-cliente-nombre {
  font-size: 14px;
  font-weight: 800;
  color: var(--sn-texto);
}

.sc-cliente-dato {
  font-size: 12px;
  color: var(--sn-texto-2);
}

.sc-enlace {
  min-height: 36px;
  padding: 4px 8px;
  border: none;
  background: none;
  color: var(--sn-marca-texto);
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
}

.sc-preview {
  display: block;
  width: 100%;
  max-height: 320px;
  object-fit: contain;
  margin-bottom: 10px;
  border: 1px solid var(--sn-borde);
  border-radius: 10px;
  background: var(--sn-superficie-2);
}

.sc-botones-foto {
  display: flex;
  gap: 8px;
}

.sc-boton-foto {
  flex: 1 1;
  min-height: 44px;
  border: 1.5px dashed var(--sn-borde-fuerte);
  border-radius: 10px;
  background: var(--sn-superficie-2);
  color: var(--sn-texto-2);
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
}

.sc-boton-foto:disabled {
  opacity: 0.6;
  cursor: default;
}

.sc-ayuda {
  margin-top: 8px;
  font-size: 11px;
  color: var(--sn-texto-3);
}

.sc-centrado {
  text-align: center;
}

.sc-error {
  margin-top: 8px;
  font-size: 12px;
  color: var(--sn-peligro-texto);
}

.sc-error--bloque {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 10px 12px;
  border-radius: 10px;
  background: var(--sn-peligro-suave);
  font-size: 13px;
  font-weight: 600;
}

/* Única acción roja de la pantalla */
.sc-principal {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  min-height: 48px;
  margin-top: 4px;
  border: none;
  border-radius: 12px;
  background: var(--sn-accion);
  color: var(--sn-accion-texto);
  font-size: 14px;
  font-weight: 800;
  box-shadow: var(--sn-sombra);
  cursor: pointer;
}

.sc-principal:disabled {
  opacity: 0.55;
  box-shadow: none;
  cursor: default;
}

.sc-resultado {
  margin-top: 14px;
  scroll-margin-top: 70px;
}

.sc-resultado-cabecera {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.sc-resultado-banco {
  font-size: 15px;
  font-weight: 800;
  color: var(--sn-texto);
}

.sc-resultado-tipo {
  font-size: 12px;
  color: var(--sn-texto-3);
}

.sc-resultado-monto {
  flex-shrink: 0;
  font-size: 26px;
  font-weight: 800;
  color: var(--sn-marca-texto);
}

.sc-cuenta {
  margin: 10px 0;
  padding: 8px 10px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 700;
}

.sc-cuenta--ok {
  background: var(--sn-exito-suave);
  color: var(--sn-exito-texto);
}

.sc-cuenta--mal {
  background: var(--sn-peligro-suave);
  color: var(--sn-peligro-texto);
}

.sc-cuenta--duda {
  background: var(--sn-alerta-suave);
  color: var(--sn-alerta-texto);
}

.sc-filas {
  border: 1px solid var(--sn-borde);
  border-radius: 10px;
  overflow: hidden;
}

.sc-fila {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  padding: 8px 12px;
  font-size: 12px;
  border-bottom: 1px solid var(--sn-borde);
}

.sc-fila:last-child {
  border-bottom: none;
}

.sc-fila span {
  flex-shrink: 0;
  color: var(--sn-texto-3);
}

.sc-fila strong {
  color: var(--sn-texto);
  text-align: right;
  word-break: break-word;
}

/* Texto OCR tal cual lo leyó Vision, con sus saltos de línea */
.sc-texto {
  max-height: 340px;
  overflow: auto;
  margin: 0 0 8px;
  padding: 10px 12px;
  border: 1px solid var(--sn-borde);
  border-radius: 10px;
  background: var(--sn-superficie-2);
  color: var(--sn-texto);
  font-family: inherit;
  font-size: 13px;
  line-height: 1.5;
  white-space: pre-wrap;
  word-break: break-word;
}

.sc-observacion {
  margin-top: 8px;
  font-size: 12px;
  color: var(--sn-texto-2);
}

.sc-drive-nombre {
  font-size: 12px;
  color: var(--sn-texto-2);
  margin-bottom: 8px;
  word-break: break-all;
}

.sc-acciones {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
}

.sc-acciones .sc-boton {
  padding: 8px 6px;
  font-size: 12px;
  line-height: 1.2;
  text-align: center;
}

.sc-boton {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 1 1;
  min-height: 42px;
  padding: 8px 12px;
  border: 1.5px solid var(--sn-borde-fuerte);
  border-radius: 10px;
  background: var(--sn-superficie-2);
  color: var(--sn-texto);
  font-size: 13px;
  font-weight: 700;
  text-decoration: none;
  cursor: pointer;
}

.sc-boton--ancho {
  width: 100%;
  margin-top: 12px;
}

/* Respuesta cruda de Vision (JSON) cuando no reconoció texto */
.sc-texto--crudo {
  font-family: ui-monospace, Consolas, monospace;
  font-size: 11px;
}

/* Lista de comprobantes leídos en la sesión */
.sc-historial {
  border: 1px solid var(--sn-borde);
  border-radius: 10px;
  overflow: hidden;
}

.sc-historial-fila {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 10px;
  border-bottom: 1px solid var(--sn-borde);
}

.sc-historial-fila:last-child {
  border-bottom: none;
}

.sc-historial-texto {
  min-width: 0;
  font-size: 12px;
  color: var(--sn-texto-2);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sc-historial-hora {
  font-weight: 700;
  color: var(--sn-texto);
}
`, "",{"version":3,"sources":["webpack://./src/pages/SubirComprobante.css"],"names":[],"mappings":"AAAA,yEAAyE;;AAEzE;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gCAAgC;EAChC,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,iCAAiC;EACjC,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,0CAA0C;EAC1C,mBAAmB;EACnB,gCAAgC;EAChC,sBAAsB;EACtB,eAAe;EACf,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,wCAAwC;EACxC,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,iCAAiC;EACjC,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,2CAA2C;EAC3C,mBAAmB;EACnB,kCAAkC;EAClC,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,mCAAmC;EACnC,eAAe;EACf,gBAAgB;AAClB;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,4BAA4B;EAC5B,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,4BAA4B;AAC9B;;AAEA;EACE,mCAAmC;EACnC,8BAA8B;AAChC;;AAEA;EACE,kCAAkC;EAClC,6BAA6B;AAC/B;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,iBAAiB;EACjB,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA,+DAA+D;AAC/D;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,iCAAiC;EACjC,mBAAmB;EACnB,kCAAkC;EAClC,sBAAsB;EACtB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,SAAO;EACP,gBAAgB;EAChB,iBAAiB;EACjB,0CAA0C;EAC1C,mBAAmB;EACnB,kCAAkC;EAClC,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA,+DAA+D;AAC/D;EACE,8CAA8C;EAC9C,eAAe;AACjB;;AAEA,8CAA8C;AAC9C;EACE,iCAAiC;EACjC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,iBAAiB;EACjB,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,wBAAwB;EACxB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB","sourcesContent":["/* SubirComprobante.css — /menu/comprobantes (tokens del tema, sin hex) */\n\n.sc-cabecera {\n  position: sticky;\n  top: 0;\n  z-index: 10;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 16px;\n  background: var(--sn-superficie);\n  border-bottom: 1px solid var(--sn-borde);\n}\n\n.sc-volver {\n  padding: 4px;\n  border: none;\n  background: none;\n  color: var(--sn-accion);\n  cursor: pointer;\n}\n\n.sc-titulo {\n  font-size: 15px;\n  font-weight: 700;\n  color: var(--sn-texto);\n}\n\n.sc-cuerpo {\n  max-width: 500px;\n  margin: 0 auto;\n  padding: 16px 16px 24px;\n}\n\n.sc-tarjeta {\n  padding: 12px 14px;\n  margin-bottom: 12px;\n  border: 1px solid var(--sn-borde);\n  border-radius: 14px;\n  background: var(--sn-superficie);\n}\n\n.sc-seccion {\n  margin-bottom: 8px;\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--sn-texto-3);\n}\n\n.sc-entrada {\n  width: 100%;\n  min-height: 42px;\n  padding: 9px 12px;\n  border: 1.5px solid var(--sn-borde-fuerte);\n  border-radius: 10px;\n  background: var(--sn-superficie);\n  color: var(--sn-texto);\n  font-size: 14px;\n  outline: none;\n  box-sizing: border-box;\n}\n\n.sc-entrada:focus {\n  border-color: var(--sn-foco-borde);\n  box-shadow: 0 0 0 3px var(--sn-foco);\n}\n\n.sc-lista {\n  margin-top: 6px;\n  border: 1px solid var(--sn-borde);\n  border-radius: 10px;\n  overflow: hidden;\n}\n\n.sc-opcion {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  width: 100%;\n  min-height: 44px;\n  padding: 8px 12px;\n  border: none;\n  border-bottom: 1px solid var(--sn-borde);\n  background: var(--sn-superficie);\n  text-align: left;\n  cursor: pointer;\n}\n\n.sc-opcion:last-child {\n  border-bottom: none;\n}\n\n.sc-opcion-nombre {\n  font-size: 13px;\n  font-weight: 700;\n  color: var(--sn-texto);\n}\n\n.sc-opcion-dato {\n  font-size: 11px;\n  color: var(--sn-texto-3);\n}\n\n.sc-cliente {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n}\n\n.sc-cliente-nombre {\n  font-size: 14px;\n  font-weight: 800;\n  color: var(--sn-texto);\n}\n\n.sc-cliente-dato {\n  font-size: 12px;\n  color: var(--sn-texto-2);\n}\n\n.sc-enlace {\n  min-height: 36px;\n  padding: 4px 8px;\n  border: none;\n  background: none;\n  color: var(--sn-marca-texto);\n  font-size: 12px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.sc-preview {\n  display: block;\n  width: 100%;\n  max-height: 320px;\n  object-fit: contain;\n  margin-bottom: 10px;\n  border: 1px solid var(--sn-borde);\n  border-radius: 10px;\n  background: var(--sn-superficie-2);\n}\n\n.sc-botones-foto {\n  display: flex;\n  gap: 8px;\n}\n\n.sc-boton-foto {\n  flex: 1;\n  min-height: 44px;\n  border: 1.5px dashed var(--sn-borde-fuerte);\n  border-radius: 10px;\n  background: var(--sn-superficie-2);\n  color: var(--sn-texto-2);\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.sc-boton-foto:disabled {\n  opacity: 0.6;\n  cursor: default;\n}\n\n.sc-ayuda {\n  margin-top: 8px;\n  font-size: 11px;\n  color: var(--sn-texto-3);\n}\n\n.sc-centrado {\n  text-align: center;\n}\n\n.sc-error {\n  margin-top: 8px;\n  font-size: 12px;\n  color: var(--sn-peligro-texto);\n}\n\n.sc-error--bloque {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 10px 12px;\n  border-radius: 10px;\n  background: var(--sn-peligro-suave);\n  font-size: 13px;\n  font-weight: 600;\n}\n\n/* Única acción roja de la pantalla */\n.sc-principal {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  width: 100%;\n  min-height: 48px;\n  margin-top: 4px;\n  border: none;\n  border-radius: 12px;\n  background: var(--sn-accion);\n  color: var(--sn-accion-texto);\n  font-size: 14px;\n  font-weight: 800;\n  box-shadow: var(--sn-sombra);\n  cursor: pointer;\n}\n\n.sc-principal:disabled {\n  opacity: 0.55;\n  box-shadow: none;\n  cursor: default;\n}\n\n.sc-resultado {\n  margin-top: 14px;\n  scroll-margin-top: 70px;\n}\n\n.sc-resultado-cabecera {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.sc-resultado-banco {\n  font-size: 15px;\n  font-weight: 800;\n  color: var(--sn-texto);\n}\n\n.sc-resultado-tipo {\n  font-size: 12px;\n  color: var(--sn-texto-3);\n}\n\n.sc-resultado-monto {\n  flex-shrink: 0;\n  font-size: 26px;\n  font-weight: 800;\n  color: var(--sn-marca-texto);\n}\n\n.sc-cuenta {\n  margin: 10px 0;\n  padding: 8px 10px;\n  border-radius: 8px;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.sc-cuenta--ok {\n  background: var(--sn-exito-suave);\n  color: var(--sn-exito-texto);\n}\n\n.sc-cuenta--mal {\n  background: var(--sn-peligro-suave);\n  color: var(--sn-peligro-texto);\n}\n\n.sc-cuenta--duda {\n  background: var(--sn-alerta-suave);\n  color: var(--sn-alerta-texto);\n}\n\n.sc-filas {\n  border: 1px solid var(--sn-borde);\n  border-radius: 10px;\n  overflow: hidden;\n}\n\n.sc-fila {\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 8px 12px;\n  font-size: 12px;\n  border-bottom: 1px solid var(--sn-borde);\n}\n\n.sc-fila:last-child {\n  border-bottom: none;\n}\n\n.sc-fila span {\n  flex-shrink: 0;\n  color: var(--sn-texto-3);\n}\n\n.sc-fila strong {\n  color: var(--sn-texto);\n  text-align: right;\n  word-break: break-word;\n}\n\n/* Texto OCR tal cual lo leyó Vision, con sus saltos de línea */\n.sc-texto {\n  max-height: 340px;\n  overflow: auto;\n  margin: 0 0 8px;\n  padding: 10px 12px;\n  border: 1px solid var(--sn-borde);\n  border-radius: 10px;\n  background: var(--sn-superficie-2);\n  color: var(--sn-texto);\n  font-family: inherit;\n  font-size: 13px;\n  line-height: 1.5;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n.sc-observacion {\n  margin-top: 8px;\n  font-size: 12px;\n  color: var(--sn-texto-2);\n}\n\n.sc-drive-nombre {\n  font-size: 12px;\n  color: var(--sn-texto-2);\n  margin-bottom: 8px;\n  word-break: break-all;\n}\n\n.sc-acciones {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 8px;\n}\n\n.sc-acciones .sc-boton {\n  padding: 8px 6px;\n  font-size: 12px;\n  line-height: 1.2;\n  text-align: center;\n}\n\n.sc-boton {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: 1;\n  min-height: 42px;\n  padding: 8px 12px;\n  border: 1.5px solid var(--sn-borde-fuerte);\n  border-radius: 10px;\n  background: var(--sn-superficie-2);\n  color: var(--sn-texto);\n  font-size: 13px;\n  font-weight: 700;\n  text-decoration: none;\n  cursor: pointer;\n}\n\n.sc-boton--ancho {\n  width: 100%;\n  margin-top: 12px;\n}\n\n/* Respuesta cruda de Vision (JSON) cuando no reconoció texto */\n.sc-texto--crudo {\n  font-family: ui-monospace, Consolas, monospace;\n  font-size: 11px;\n}\n\n/* Lista de comprobantes leídos en la sesión */\n.sc-historial {\n  border: 1px solid var(--sn-borde);\n  border-radius: 10px;\n  overflow: hidden;\n}\n\n.sc-historial-fila {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 8px 10px;\n  border-bottom: 1px solid var(--sn-borde);\n}\n\n.sc-historial-fila:last-child {\n  border-bottom: none;\n}\n\n.sc-historial-texto {\n  min-width: 0;\n  font-size: 12px;\n  color: var(--sn-texto-2);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.sc-historial-hora {\n  font-weight: 700;\n  color: var(--sn-texto);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
